import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import * as moment from 'moment';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { Dropdown } from 'primeng/dropdown';
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver/src/FileSaver';
import { AcademyService } from '../service/academies.service';
import { DiscountCouponsService } from 'src/app/services/discount-coupons.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Calendar } from 'primeng/calendar'; 

@Component({
  selector: 'app-discount-coupons',
  templateUrl: './discount-coupons.component.html',
  styleUrls: ['./discount-coupons.component.scss'],
  providers: [ConfirmationService, MessageService]
})

export class DiscountCouponsComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public hide: boolean = true;
  searchBy: any[] = [];
  searchby: any;
  startDate: Date;
  endDate: Date;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  @ViewChild("pCalendarId", { static: false }) pCalendarId: Calendar;
  public lastTableLazyLoadEvent: LazyLoadEvent;
  discountCouponData: any;
  totalDiscountCouponDataCount: number = 0;
  paginationOption: any;
  calvalue: Date;
  startDateCalValue: Date;
  endDateCalValue: Date;
  createdAtCalValue: Date;
  updatedAtCalValue: Date;
  statuses: any[];
  errorMessage: any;
  showThumbNailImage: boolean = false;
  loading: boolean;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  thumbnailImageArray: any[] = [];
  downloadFlg: boolean;
  downloadDiscountCouponsList: any;
  academyId: string;
  academyDetails: any;
  academyName: any;

  constructor(private router: Router, private discountCouponService: DiscountCouponsService, private messageService: MessageService, private confirmationService: ConfirmationService, private activatedRoute: ActivatedRoute, private academyService: AcademyService) { }

  ngOnInit(): void {
    this.paginationOption = environment.pagination;
    this.academyId = this.activatedRoute.snapshot.paramMap.get('academyId');
    this.searchBy = [
      { label: 'Created On', value: "created_at" },
      { label: 'Last Modified On', value: "updated_at" },
      { label: 'Start Date', value: "startDate" },
      { label: 'End Date', value: "endDate" },
    ];
    this.statuses = [
      { label: 'Active', value: true },
      { label: 'In-Active', value: false }
    ];
    if (this.academyId) {
      this.getAcademyDetails(this.academyId);
    }
  }

  getAcademyDetails(id) {
    this.academyService.getAcademyDetails(id).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.loading = false;
        this.academyDetails = data;
        this.academyName = this.academyDetails['name'];
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

  addNewCoupon() {
    if (this.academyId) {
      this.router.navigate(['/manage/academies/discount-coupons/add/' + this.academyId]);
    } else {
      this.router.navigate(['/manage/discount-coupons/add']);
    }
  }

  loadDiscountCouponList(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    let query = "?filterByDisable=false";
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = (event.first / event.rows) + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }

    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }

    if (event.filters != undefined && event.filters["name"] != undefined) {
      params += "&filterByname=" + event.filters["name"].value;
    }
    if (event.filters != undefined && event.filters["moduleName"] != undefined) {
      params += "&filterByModuleName=" + event.filters["moduleName"].value;
    }
    if (event.filters != undefined && event.filters["description"] != undefined) {
      params += "&filterBydescription=" + event.filters["description"].value;
    }
    if (event.filters != undefined && event.filters["usageData"] != undefined) {
      params += "&filterByUsageData=" + event.filters["usageData"].value;
    }
    if (event.filters != undefined && event.filters["code"] != undefined) {
      params += "&filterBycode=" + event.filters["code"].value;
    }
    if (event.filters != undefined && event.filters["status"] != undefined) {
      params += "&filterByStatus=" + event.filters["status"].value;
    }
    if (event.filters != undefined && event.filters["createdBy"] != undefined) {
      params += "&filterByCreatedBy=" + event.filters["createdBy"].value;
    }
    if (event.filters != undefined && event.filters["updatedBy"] != undefined) {
      params += "&filterByUpdatedBy=" + event.filters["updatedBy"].value;
    }

    // at the time of download hide pagination option
    if (this.downloadFlg !== true) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField && event.sortOrder) {
      let orderBy = event.sortOrder == 1 ? "DESC" : "ASC";
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }

    if (this.academyId !== null) {
      query += "&filterByAcademyId=" + this.academyId;
    }

    this.discountCouponService.getAllDiscountCoupons(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (this.downloadFlg === true) {
        this.exportExcelSheet(data.data.items);
      } else {
        this.discountCouponData = data.data.items;
        this.totalDiscountCouponDataCount = data.data.totalCount;
      }
    }, (error) => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: error.error.message, life: 6000 });
    })
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.startDateCalValue = null;
    this.endDateCalValue = null;
    this.createdAtCalValue = null;
    this.updatedAtCalValue = null;
    this.searchby = '';
    this.dt.filter('', 'name', 'contains');
    this.dt.filter('', 'description', 'contains');
    this.dt.filter('', 'usageData', 'contains');
    this.dt.filter('', 'code', 'contains');
    this.dt.filter('', 'status', 'contains');
    this.dt.filter('', 'createdBy', 'contains');
    this.dt.filter('', 'updatedBy', 'contains');
    this.pDropDownId.clear(null);
    if (this.pDropDownId) {
      this.pDropDownId.value = null;
    }
    if (this.pCalendarId) {
    this.pCalendarId.value = null;
    this.pCalendarId.updateInputfield();
    }
    this.dt.reset();
    this.dt.first = 0;
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadDiscountCouponList(this.lastTableLazyLoadEvent);
  }

  exportExcelSheet(featuredThisWeekList) {
    var propertiesRemove = ['id', 'academyId','availability', 'moduleId','refund', 'termsAndCondition', 'disable', 'created_at', 'created_by', 'updated_at', 'updated_by'];
    this.downloadDiscountCouponsList = featuredThisWeekList;
    this.downloadDiscountCouponsList.forEach(function (item) {
      if (item.status) {
        item['status'] = 'Active';
      } else {
        item['status'] = 'In-Active';
      }
      if (item.usageData.length > 0) {
        item['usageData'] = item.usageData[0]['name'];
      }
      propertiesRemove.forEach(function (prop) {
        delete item[prop];
      });
    });
    this.downloadDiscountCouponsList.forEach(function (item) {
      propertiesRemove.forEach(function (prop) {
        delete item[prop];
      });
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.downloadDiscountCouponsList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, "DiscountCouponsList");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  changeStatus(discountCouponData) {
    this.confirmationService.confirm({
      // message: 'Are you sure you want to change the status of  ' + (this.titlecasePipe.transform(discountCouponData.title)) + '?',
      // header: 'Confirm',
      // icon: 'pi pi-exclamation-triangle',
      message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to change this status ?
      </p>
    `,
      // message: 'Are you sure you want to delete this image ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
      rejectLabel: 'Cancel',
      // ❌ Remove icons
      acceptIcon: '',
      rejectIcon: '',
      accept: () => {
        var updatedata = {};
        updatedata['status'] = discountCouponData.status;
        this.discountCouponService.updateDiscountCoupon(discountCouponData.id, updatedata).pipe(takeUntil(this.destroy$)).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Discount Coupon Status Updated', life: 3000 });
            setTimeout(() => {
              this.loadDiscountCouponList(this.lastTableLazyLoadEvent);
            }, 1000);
          },
          err => {
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        discountCouponData.status = !discountCouponData.status;
        this.loadDiscountCouponList(this.lastTableLazyLoadEvent);
      }
    });
  }

  onDelete(discountCouponData) {
    this.confirmationService.confirm({
      // message: 'Are you sure you want to delete ' +(this.titlecasePipe.transform(discountCouponData.title))+ '?',
      // header: 'Confirm',
      // icon: 'pi pi-exclamation-triangle',
      message: `
      <h4 style="margin:0;">Delete Coupon</h4>
      <p style="margin-top:10px;">
        Are you sure you want to delete the coupon?
      </p>
    `,
      // message: 'Are you sure you want to delete this image ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
      rejectLabel: 'Cancel',
      // ❌ Remove icons
      acceptIcon: '',
      rejectIcon: '',

      accept: () => {
        var updatedata = '{"disable":true}';
        // console.log(cmsmodule._id);
        this.discountCouponService.updateDiscountCoupon(discountCouponData.id, updatedata).pipe(takeUntil(this.destroy$)).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Coupon Deleted Successfully!', life: 3000 });
            this.loadDiscountCouponList(this.lastTableLazyLoadEvent);
          },
          err => {
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        this.loadDiscountCouponList(this.lastTableLazyLoadEvent);
      }
    });
  }
  onEditCoupon(discountCouponData) {
    if (this.academyId) {
      this.router.navigate(['/manage/academies/discount-coupons/edit/' + this.academyId + '/' + discountCouponData.id]);
    } else {
      this.router.navigate(['/manage/discount-coupons/edit/' + discountCouponData.id]);
    }
  }
  addColumns() {
    this.hide = false;

  }

  /**
  * Use to remove more columns in the table.
  */
  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
